import { MantineDataTable } from '@flexinet/ui-components';
import { Stack } from '@mantine/core';
import { useAllContacts } from '../hooks/useAllContacts';
import { useContactsTableColumns } from '../hooks/useContactsTableColumns';
import { DataTableTokenPagination } from '../../../components/DataTableTokenPagination';
import { useRef } from 'react';

export const ContactsTable = () => {
    const { visibleItems, loading, nextToken, fetchRecords, isFetchingNextPage, visibleCount } = useAllContacts();
    const columns = useContactsTableColumns();
    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack gap="lg">
            <MantineDataTable
                columns={columns}
                records={visibleItems}
                fetching={loading}
                withTableBorder={true}
                onScrollToBottom={fetchRecords}
                scrollViewportRef={scrollViewportRef}
            />
            <DataTableTokenPagination
                totalCount={visibleCount.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                loading={isFetchingNextPage}
            />
        </Stack>
    );
};
